module.exports = __webpack_public_path__ + "/images/logo-af-zara.b8d7e06.svg";